import { render, staticRenderFns } from "./crearEmpresa.vue?vue&type=template&id=34a47d20"
import script from "./crearEmpresa.vue?vue&type=script&lang=js"
export * from "./crearEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports